// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"table-state_noDataContainer__2MTk2","error":"table-state_error__HyFpq","noDataContainer__modal":"table-state_noDataContainer__modal__3hSZu"};